// Överst ska det vara ett fält där man kan skriva en kommentar
// Sen listar vi alla kommentarer, den senaste längst ner.
// Den ska vara overflow så man får scrolla i listan. Se till att ha scrollat längst ner hela tiden vaaa?
// NEJ Kör överifrån och ner, enklast
// Det är dags att återinföra användar--färg
// En kommentar innehåller namn, tidpunkt (relativ), text
// Grejer man skrivit själv får ligga på höger-sidan med annan färg, resten på vänstersidan
//

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createUppdragComment, UppdragQueryKey } from "api/uppdrag.api";
import SecondaryButton from "components/buttons/SecondaryButton";
import Divider from "components/Divider";
import { ContentContainer, HeaderContainer } from "components/ShadowCard";
import { Headline4 } from "components/typography/Headline4";
import { Headline5 } from "components/typography/Headline5";
import { formatDateWithTimeRelative } from "helpers/date";
import { useNotification } from "hooks/useNotification";
import { useState } from "react";
import { Uppdrag } from "types/uppdrag.type";

type Props = {
  uppdrag: Uppdrag;
};
export const CommentLog = ({ uppdrag }: Props) => {
  const qk = useQueryClient();
  const n = useNotification();
  const [comment, setComment] = useState("");
  const postCommentMutation = useMutation({
    ...createUppdragComment(),
    onSuccess: () => {
      qk.invalidateQueries({ queryKey: [UppdragQueryKey.GetOne] });
      setComment("");
    },
    onError: () => {
      n.error();
    },
  });

  const postComment = () => {
    if (!comment) {
      return;
    }
    postCommentMutation.mutate({ uppdragId: uppdrag.id, comment });
  };
  return (
    <div className="w-full divide-y divide-gray-200 rounded-xl bg-white">
      <HeaderContainer>
        <Headline4>Interna kommentarer</Headline4>
      </HeaderContainer>
      <ContentContainer>
        <>
          <Input
            comment={comment}
            setComment={(v: string) => setComment(v)}
            postComment={postComment}
          />
          <Divider className="mb-4 mt-4" />
          <div className="flex flex-col overflow-y-auto">
            {uppdrag.comments.map((c) => (
              <div key={c.id} className="mb-6 flex flex-col">
                <div className="flex items-center justify-start">
                  {/* <InitialsAvatar name={"klas len"} className="mr-2" /> */}
                  <Headline5>{c.userName}</Headline5>
                  <span className="font-base ml-2 text-xs text-gray-500">
                    {formatDateWithTimeRelative(new Date(c.createdAtUtc))}
                  </span>
                </div>
                <p className="mt-1.5 text-gray-900 sm:text-sm">{c.comment}</p>
              </div>
            ))}
          </div>
        </>
      </ContentContainer>
    </div>
  );
};

type InputProps = {
  postComment: () => void;
  setComment: (v: string) => void;
  comment: string;
};
const Input = ({ comment, setComment, postComment }: InputProps) => {
  return (
    <div className="flex items-start space-x-4">
      {/* <div className="shrink-0">
        <InitialsAvatar name="Pontus Lindström" />
      </div> */}
      <div className="min-w-0 flex-1">
        <form action="#" className="relative">
          <div className="rounded-lg bg-white outline outline-1 -outline-offset-1 outline-gray-200 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-cyan-600">
            <label htmlFor="comment" className="sr-only">
              Skriv en kommentar
            </label>
            <textarea
              id="comment"
              name="comment"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              rows={2}
              placeholder="Skriv en kommentar..."
              className="block w-full resize-none border-none bg-transparent px-3 text-base text-gray-900 outline-none placeholder:text-gray-400 focus:border-none focus:shadow-none focus:outline-none focus:ring-0 sm:text-sm/6"
              defaultValue={""}
            />

            {/* Spacer element to match the height of the toolbar */}
            <div aria-hidden="true">
              {/* Matches height of button in toolbar (1px border + 36px content height) */}
              <div className="py-px">
                <div className="h-8" />
              </div>
            </div>
          </div>

          <div className="absolute inset-x-0 bottom-0 flex justify-end py-1 pl-3 pr-2">
            <div className="shrink-0">
              <SecondaryButton
                color="black"
                size="small"
                disabled={!comment}
                onClick={postComment}
              >
                Spara
              </SecondaryButton>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
